export var sanitizeTitle = function (title) {
    var sanitizedTitle = title.replace(' ', '-');
    sanitizedTitle = sanitizedTitle.replace(/[\$\+\/\?\!\#\~\<\>\[\]\{\}\(\)\\\^%|@:;=,&"\'\`\—\–]/g, '');
    sanitizedTitle = sanitizedTitle.replace(/[_. \-]+/g, '-');
    sanitizedTitle = sanitizedTitle.replace(/^\-|\-$/g, '');
    return sanitizedTitle;
};
export var getClassUrl = function (title, sku, via) {
    if (via === void 0) { via = 'search-layout-grid'; }
    var titlePath = sanitizeTitle(title);
    return "/classes/" + titlePath + "/" + sku + "?via=" + via;
};
export var getTeacherUrl = function (teacher, via) {
    if (teacher.vanityUsername) {
        return "/user/" + teacher.vanityUsername + "?via=" + (via !== null && via !== void 0 ? via : 'card-search');
    }
    return "/profile/" + teacher.name.split(' ').join('-') + "/" + teacher.username + "?via=" + (via !== null && via !== void 0 ? via : 'card-search');
};
//# sourceMappingURL=url-formatter.js.map